import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { SMOKE_TEST_HISTORY_PATH_NAME } from './smoke-test-history.constants';
import {
  SmokeTestHistoryResponseSchema,
  StoryTraceStepVisibilityBodySchema,
} from './smoke-test-history.schema';

export const SmokeTestHistoryContract = terraContract
  .prefix(`/${SMOKE_TEST_HISTORY_PATH_NAME}`)
  .router({
    getSmokeTestHistoryByThreadId: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_TESTS.name],
      })
      .route({
        method: 'GET',
        path: '/{applicationId}/{threadId}',
        summary: 'Get smoke test history by thread ID',
        inputStructure: 'detailed',
      })
      .input(
        z.object({
          params: z.object({
            applicationId: z.string(),
            threadId: z.string(),
          }),
        }),
      )
      .output(SmokeTestHistoryResponseSchema)
      .errors({
        NOT_FOUND: {
          status: 404,
          data: z.object({
            message: z.string(),
          }),
        },
      }),
    setStoryTraceStepVisibility: terraContract
      .meta({
        permissions: [PERMISSIONS.EXECUTE_TESTS.name],
      })
      .route({
        method: 'PATCH',
        path: '/{applicationId}/{threadId}/steps/{stepKey}/visibility',
        summary: 'Set visibility for a story-trace step',
        inputStructure: 'detailed',
      })
      .input(
        z.object({
          params: z.object({
            applicationId: z.string(),
            threadId: z.string(),
            stepKey: z.string(),
          }),
          body: StoryTraceStepVisibilityBodySchema,
        }),
      )
      .output(SmokeTestHistoryResponseSchema)
      .errors({
        NOT_FOUND: {
          status: 404,
          data: z.object({
            message: z.string(),
          }),
        },
      }),
  });
